var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        name: "photo-add-new-modal",
        pivotY: 0.2,
        width: 496,
        height: "auto"
      }
    },
    [
      _c("div", { staticClass: "modal-close-btn-point" }, [
        _c(
          "div",
          {
            staticClass: "modal-close-btn-container",
            on: {
              click: function($event) {
                return _vm.hideModal("photo-add-new-modal")
              }
            }
          },
          [_c("SVGModalClose")],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-title-big" }, [
        _vm._v("\n            Добавить фото\n        ")
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", { staticClass: "modal-list" }, [
          _vm._v("\n                JPG, JPEG, PNG форматы\n            ")
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "modal-list" }, [
          _vm._v(
            "\n                Не более 15 МБ в размере файла\n            "
          )
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "modal-list" }, [
          _vm._v(
            "\n                Высокое разрешение и в фокусе\n            "
          )
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "modal-list" }, [
          _vm._v("\n                Беспрепятственный вид на дом\n            ")
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "modal-list" }, [
          _vm._v(
            "\n                В центре внимания - область интересов\n            "
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dnd-container mb-40",
          on: {
            drop: function($event) {
              $event.preventDefault()
              return _vm.receiveFiles($event)
            },
            dragover: function($event) {
              $event.preventDefault()
              _vm.dragover = true
            },
            dragleave: function($event) {
              $event.preventDefault()
              _vm.dragover = false
            },
            click: function($event) {
              return _vm.$refs.file.click()
            }
          }
        },
        [_c("SVGPhotoDnDLoad", { attrs: { dragover: _vm.dragover } })],
        1
      ),
      _vm._v(" "),
      _c("input", {
        ref: "file",
        attrs: {
          type: "file",
          id: "fileInputModal",
          accept: ".jpg,.png",
          multiple: "",
          hidden: ""
        },
        on: {
          change: function($event) {
            return _vm.handleFileUpload($event)
          }
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }